import React from 'react';
import EventFieldDescription from './EventFieldDescription';
import {
    constructEventDateTimeString,
    formatDisplayNumber,
} from '../../FormUtils';

const EventFieldMap = ({ fieldName, eventData, eventIsAllowParticipate }) => {
    switch (fieldName) {
        case 'venue':
            return (
                <EventFieldDescription
                    fieldName="สถานที่จัดกิจกรรม"
                    value={eventData.venue ? eventData.venue : '-'}
                />
            );
        case 'mainCoordinator':
            return (
                <EventFieldDescription
                    fieldName="ผู้ประสานงานหลัก"
                    value={
                        eventData.mainCoordinator
                            ? eventData.mainCoordinator.fullName
                            : '-'
                    }
                />
            );
        case 'eventStartDate':
            return (
                <EventFieldDescription
                    fieldName="วันที่เริ่มกิจกรรม"
                    value={
                        eventData.eventStartDate
                            ? constructEventDateTimeString(
                                  eventData.eventStartDate,
                                  eventData.eventStartTime
                              )
                            : '-'
                    }
                />
            );
        case 'coordinators':
            return (
                <EventFieldDescription
                    fieldName="ผู้ช่วยจัดกิจกรรม"
                    value={
                        Array.isArray(eventData.coordinators)
                            ? eventData.coordinators.length > 0
                                ? eventData.coordinators
                                      .map((coord) => coord.fullName)
                                      .join(', ')
                                : '-'
                            : '-'
                    }
                />
            );
        case 'eventEndDate':
            return (
                <EventFieldDescription
                    fieldName="วันที่สิ้นสุดกิจกรรม"
                    value={
                        eventData.eventEndDate
                            ? constructEventDateTimeString(
                                  eventData.eventEndDate,
                                  eventData.eventEndTime
                              )
                            : '-'
                    }
                />
            );
        case 'isPublic':
            return (
                <EventFieldDescription
                    fieldName="การเผยแพร่กิจกรรม"
                    value={
                        eventData.isPublic
                            ? 'เปิดเผยสาธารณะ'
                            : 'เฉพาะผู้จัดกิจกรรม/ตามรายชื่อที่กำหนด'
                    }
                />
            );
        case 'reserveStartDate':
            return (
                <EventFieldDescription
                    fieldName="วันที่เปิดลงทะเบียนล่วงหน้า"
                    value={
                        eventData.reserveStartDate
                            ? constructEventDateTimeString(
                                  eventData.reserveStartDate,
                                  eventData.reserveStartTime
                              )
                            : '-'
                    }
                />
            );
        case 'hasCapacity':
            return (
                <EventFieldDescription
                    fieldName="เงื่อนไขการลงทะเบียน"
                    value={
                        !eventData.internalCapacity &&
                        !eventData.externalCapacity
                            ? 'ไม่กำหนด'
                            : 'ตามจำนวนที่กำหนด'
                    }
                />
            );
        case 'reserveEndDate':
            return (
                <EventFieldDescription
                    fieldName="วันที่สิ้นสุดการลงทะเบียนล่วงหน้า"
                    value={
                        eventData.reserveEndDate
                            ? constructEventDateTimeString(
                                  eventData.reserveEndDate,
                                  eventData.reserveEndTime
                              )
                            : '-'
                    }
                />
            );
        case 'isAllowAnyOne':
            return (
                <EventFieldDescription
                    fieldName="เงื่อนไขผู้เข้าร่วม"
                    value={eventIsAllowParticipate}
                    isArray={true}
                />
            );
        case 'isRequiredCheckin':
            return (
                <EventFieldDescription
                    fieldName="รูปแบบการลงทะเบียนเข้างาน"
                    value={
                        eventData.isRequiredCheckin
                            ? 'ณ สถานที่จัดกิจกรรม'
                            : 'ไม่กำหนด (ไม่ต้องลงทะเบียนเข้างานในวันจัดกิจกรรม)'
                    }
                />
            );
        case 'checkInLeadTime':
            return (
                <EventFieldDescription
                    fieldName="เวลาที่เปิดให้ลงทะเบียนเข้างานก่อนเริ่มกิจกรรม (นาที)"
                    value={
                        eventData.checkInLeadTime
                            ? eventData.checkInLeadTime + ' นาที'
                            : '-'
                    }
                />
            );
        case 'status':
            return (
                <EventFieldDescription
                    fieldName="สถานะกิจกรรม"
                    value={eventData.statusName ? eventData.statusName : '-'}
                />
            );
        case 'reserveFile':
            return (
                <EventFieldDescription
                    fieldName="รายชื่อที่นำเข้าล่วงหน้า"
                    value={eventData.reserveFile}
                    download={true}
                />
            );
        case 'internalCapacity':
            return (
                <EventFieldDescription
                    fieldName="จำนวนโควต้าพนักงานและลูกจ้างพนักงานที่กำหนด"
                    value={
                        eventData.internalCapacity === null
                            ? 'ไม่จำกัดจำนวน'
                            : eventData.internalCapacity
                            ? formatDisplayNumber(eventData.internalCapacity)
                            : '-'
                    }
                />
            );
        case 'externalCapacity':
            return (
                <EventFieldDescription
                    fieldName="จำนวนโควต้าบุคคลภายนอกที่กำหนด"
                    value={
                        eventData.externalCapacity === null
                            ? 'ไม่จำกัดจำนวน'
                            : eventData.externalCapacity
                            ? formatDisplayNumber(eventData.externalCapacity)
                            : '-'
                    }
                />
            );
        default:
            return <></>;
    }
};

export default EventFieldMap;
